import { Locale } from "./i18n";

export default {
    // Changed display name and code to Spanish
    display: "Español",
    code: "es",
    translation: {
        // Basic shape translations
        "arc.angle": "Ángulo",
        "arc.start": "Inicio",
        "axis.x": "Eje X",
        "axis.y": "Eje Y",
        "axis.z": "Eje Z",
        "body.arc": "Arco",
        "body.bolean": "Booleano",
        "body.box": "Caja",
        "body.circle": "Círculo",
        "body.face": "Cara",
        "body.fuse": "Fusión",
        "body.imported": "Importado",
        "body.line": "Línea",
        "body.polygon": "Polígono",
        "body.prism": "Prisma",
        "body.rect": "Rectángulo",
        "body.revol": "Revolución",
        "body.sweep": "Barrido",
        "body.wire": "Alambre",
        "box.dx": "Longitud",
        "box.dy": "Ancho",
        "box.dz": "Altura",
        "body.editableShape": "Forma Editable",
        "body.meshNode": "Nodo de Malla",
        "body.multiShape": "Forma Múltiple",
        "circle.center": "Centro",
        "circle.radius": "Radio",

        // Commands translations
        "command.arc": "Arco",
        "command.array": "Matriz",
        "command.bezier": "Bézier",
        "command.boolean.common": "Común",
        "command.boolean.cut": "Cortar",
        "command.boolean.fuse": "Fusionar",
        "command.box": "Caja",
        "command.break": "Romper",
        "command.circle": "Círculo",
        "command.copy": "Copiar",
        "command.delete": "Eliminar",
        "command.document.new": "Nuevo Dibujo",
        "command.document.open": "Cargar Dibujo",
        "command.document.save": "Guardar",
        "command.document.saveAs": "Guardar Como",
        "command.document.saveToFile": "Guardar en Archivo",
        "command.export": "Exportar",
        "command.faceable.isFace": "Cara",
        "command.fuse": "Fusionar",
        "command.import": "Importar",
        "command.line.isConnected": "Conectado",
        "command.line": "Línea",
        "command.mirror": "Espejo",
        "command.mode.repeat": "Repetir",
        "command.move": "Mover",
        "command.newFolder": "Nueva Carpeta",
        "command.newGroup": "Nuevo Grupo",
        "command.offset": "Desplazamiento",
        "command.polygon": "Polígono",
        "command.prism": "Prisma",
        "command.rect": "Rectángulo",
        "command.redo": "Rehacer",
        "command.revol": "Revolución",
        "command.rotate": "Rotar",
        "command.section": "Sección",
        "command.split": "Dividir",
        "command.sweep": "Barrido",
        "command.thickSolid": "Sólido Grueso",
        "command.toFace": "A Cara",
        "command.toWire": "A Alambre",
        "command.trim": "Recortar",
        "command.undo": "Deshacer",

        // Common terms
        "common.angle": "Ángulo",
        "common.back": "Atrás",
        "common.cancel": "Cancelar",
        "common.clone": "Clonar",
        "common.color": "Color",
        "common.confirm": "Confirmar",
        "common.general": "General",
        "common.length": "Longitud",
        "common.material": "Material",
        "common.matrix": "Matriz",
        "common.name": "Nombre",
        "common.normal": "Normal",
        "common.opacity": "Opacidad",
        "common.thickness": "Espesor",
        "common.type": "Tipo",

        // Entity related
        "entity.editable": "Entidad Editable",
        "entity.parameter": "Entidad Paramétrica",

        // Error messages
        "error.default:{0}": "error: {0}",
        "error.input.cannotInputANumber":
            "Superposición con punto de referencia, no se puede ingresar 1 número",
        "error.input.invalidNumber": "Por favor ingrese un número válido, separado por ,",
        "error.input.threeNumberCanBeInput": "Punto de referencia vacío, solo se pueden ingresar 3 números",
        "error.input.unsupportedInputs": "Excede el número máximo de entradas",
        "error.import.unsupportedFileType:{0}": "Tipo de archivo no soportado: {0}",
        "error.export.noNodeCanBeExported": "No se puede exportar ningún nodo",

        // File and home related
        "file.format": "Formato",
        "home.recent": "Reciente",
        "home.welcome": "Bienvenido a LuminiCAD",

        // Items and tools
        "items.header": "Elementos",
        "items.tool.delete": "Eliminar",
        "items.tool.expandAll": "Expandir Todo",
        "items.tool.newFolder": "Nueva Carpeta",
        "items.tool.unexpandAll": "Contraer Todo",

        // Line properties
        "line.end": "Fin",
        "line.start": "Inicio",
        "line.type.line": "Línea",
        "line.type.xline": "Línea X",

        // Material properties
        "material.texture.image": "Imagen",
        "material.texture.rotation": "Rotación",
        "material.texture.wrapS": "Envolver S",
        "material.texture.wrapT": "Envolver T",
        "material.texture.repeat": "Repetir",
        "material.texture.offset": "Desplazamiento",
        "material.map": "Mapa",
        "material.specular": "Especular",
        "material.shininess": "Brillo",
        "material.emissive": "Emisivo",
        "material.specularMap": "Mapa Especular",
        "material.normalMap": "Mapa Normal",
        "material.bumpMap": "Mapa de Relieve",
        "material.roughnessMap": "Mapa de Rugosidad",
        "material.emissiveMap": "Mapa Emisivo",
        "material.metalness": "Metalicidad",
        "material.metalnessMap": "Mapa de Metalicidad",
        "material.roughness": "Rugosidad",

        // Model and operations
        "model.visible": "Visible",
        "operate.pickCircleCenter": "seleccionar centro, tecla ESC para cancelar",
        "operate.pickFistPoint": "Seleccionar primer punto, tecla ESC para cancelar",
        "operate.pickNextPoint": "seleccionar siguiente punto, tecla ESC para cancelar",
        "operate.pickRadius": "ingresar radio, tecla ESC para cancelar",
        "polygon.points": "Puntos",

        // Prompts and messages
        "prompt.default":
            "Botón central del ratón para desplazar la vista, Mayús + botón central para rotar la vista, botón central para zoom",
        "prompt.deleteDocument{0}": "¿Desea eliminar {0}?",
        "prompt.polygon.close": "Cerrar",
        "prompt.saveDocument{0}": "¿Desea guardar los cambios en {0}?",
        "prompt.select.edges": "Por favor seleccione aristas",
        "prompt.select.faces": "Por favor seleccione caras",
        "prompt.select.models": "Por favor seleccione modelos",
        "prompt.select.noModelSelected": "Ningún modelo seleccionado",
        "prompt.select.shape": "Por favor seleccione forma",
        "prompt.select.vertexs": "Por favor seleccione vértices",
        "prompt.select.wires": "Por favor seleccione alambres",

        // Properties and UI elements
        "properties.group.transform": "Transformación",
        "properties.header": "Propiedades",
        "properties.multivalue": "Valor Múltiple",
        "rect.dx": "Longitud",
        "rect.dy": "Ancho",

        // Ribbon interface
        "ribbon.group.boolean": "Booleano",
        "ribbon.group.converter": "Convertidor",
        "ribbon.group.draw": "Dibujo",
        "ribbon.group.importExport": "Importar/Exportar",
        "ribbon.group.modify": "Modificar",
        "ribbon.group.selection": "Selección",
        "ribbon.group.tools": "Herramientas",
        "ribbon.group.workingPlane": "Plano de Trabajo",
        "ribbon.tab.draw": "Dibujo",
        "ribbon.tab.file": "Archivo",
        "ribbon.tab.startup": "Editor",

        // Snap options
        "snap.center": "Centro",
        "snap.end": "Final",
        "snap.intersection": "Intersección",
        "snap.mid": "Medio",
        "snap.perpendicular": "Perpendicular",
        "snap.nearest": "Más Cercano",

        // Toast messages
        "toast.command.{0}excuting": "Comando {0} en ejecución",
        "toast.converter.error": "Error de conversión",
        "toast.converter.invalidColor": "El color no es válido",
        "toast.delete{0}Objects": "{0} objetos eliminados",
        "toast.document.noActived": "Ningún documento activo",
        "toast.document.saved": "Documento guardado",
        "toast.downloading": "Descargando",
        "toast.excuting{0}": "Ejecutando {0}",
        "toast.fail": "Fallo",
        "toast.read.error": "Error de lectura",
        "toast.select.noSelected": "Nada seleccionado",
        "toast.success": "Éxito",

        // Transform options
        "transform.rotation": "Rotación",
        "transform.scale": "Escala",
        "transform.translation": "Traslación",
        "vertex.point": "Punto",

        // Working plane
        "workingPlane.alignToPlane": "Alinear al plano",
        "workingPlane.set": "Establecer plano de trabajo",
        "test.performace": "Prueba de rendimiento",

        // AI Chat
        "chat.title": "Asistente IA",
        "chat.placeholder": "Escriba su solicitud CAD...",
        "command.ai.chat": "Chat IA",

        // Settings page translations
        "settings.title": "Configuración",
        "settings.profile": "Perfil",
        "settings.appearance": "Apariencia",
        "settings.shortcuts": "Atajos",
        "settings.notifications": "Notificaciones",
        "settings.privacy": "Privacidad",
        "settings.advanced": "Avanzado",

        "settings.profile.name": "Nombre completo",
        "settings.profile.email": "Correo electrónico",
        "settings.profile.bio": "Biografía",
        "settings.profile.namePlaceholder": "Ingrese su nombre",
        "settings.profile.emailPlaceholder": "Ingrese su correo",
        "settings.profile.bioPlaceholder": "Cuéntenos sobre usted",

        "settings.theme.title": "Tema",
        "settings.theme.light": "Claro",
        "settings.theme.dark": "Oscuro",

        // Working plane
        "workingPlane.toggleDynamic": "Activar/Desactivar plano de trabajo dinámico",
        "workingPlane.fromSection": "Crear plano de trabajo desde sección",

        // Labels for Shapes List panel in chat header
        "chat.shapesList.currentDocument": "Formas del Documento Actual",
        "chat.shapesList.allDocuments": "Formas de Otros Documentos",
        "chat.shapesList.noDocument": "No hay un documento activo para listar formas.",
        "chat.shapesList.noStorage": "Almacenamiento no disponible para obtener documentos.",
        "chat.shapesList.errorLoading": "Error al cargar la lista de formas.",

        "body.cylinder": "Cilindro",
        "body.cone": "Cono",
        "body.sphere": "Esfera",
        "body.ellipse": "Elipse",
        "body.pyramid": "Pirámide",
        "ellipsoid.radiusX": "Radio X (Elipsoide)",
        "ellipsoid.radiusY": "Radio Y (Elipsoide)",
        "ellipsoid.radiusZ": "Radio Z (Elipsoide)",
        "ellipse.majorRadius": "Radio Mayor (Elipse)",
        "ellipse.minorRadius": "Radio Menor (Elipse)",
        "command.pyramid": "Pirámide",
        "command.cylinder": "Cilindro",
        "command.cone": "Cono",
        "command.sphere": "Esfera",
        "command.ellipse": "Elipse",
        "command.chamfer": "Abraser",
        "command.copySubShape": "Copiar Subforma",
        "command.explode": "Explosar",
        "command.fillet": "Redondear",
        "command.removeFeature": "Eliminar función",
        "command.removeSubShapes": "Eliminar subformas",
        "command.toShell": "Vers Coque",
        "command.toSolid": "Vers Solido",
        "ribbon.group.2d": "Grupo 2D",
        "ribbon.group.3d": "Grupo 3D",
        "ribbon.group.other": "Otro",
        "ribbon.tab.tools": "Herramientas",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Rastreo",
    },
} satisfies Locale;
